<template>
  <div class="promotion-modal-page">
    <div class="promotion-card">
      <!-- 顶部邀请区域 -->
      <div class="promotion-header">
        <img :src="headerBanner" alt="" class="promotion-header-bg" />
        <div class="promotion-header-content">
          <h3 class="promotion-title">邀请好友</h3>
          <p class="promotion-subtitle">领 <span class="highlight-text">5000</span> 碱基币</p>
          <p class="promotion-desc">邀请您的朋友来一起体验吧~</p>
          <a href="javascript:void(0)" class="rule-link" @click="openRule">活动规则</a>
        </div>
        <button class="promotion-copy-btn" type="button" @click="copyPromotionLink">
          <img :src="iconLink" alt="" class="link-icon" />
          复制链接
        </button>
      </div>

      <!-- 步骤说明 -->
      <div class="promotion-steps-section">
        <h4 class="promotion-steps-title">仅需 3 步即可获得碱基币</h4>

        <div class="promotion-step-item">
          <span class="promotion-step-number blue"><img :src="num1" class="step-num-img" /></span>
          <div class="promotion-step-content">
            <h5 class="promotion-step-title">分享专属邀请链接</h5>
            <p class="promotion-step-desc">点击「复制链接」，并发送给好友</p>
          </div>
        </div>

        <div class="promotion-step-item">
          <span class="promotion-step-number purple"><img :src="num2" class="step-num-img" /></span>
          <div class="promotion-step-content">
            <h5 class="promotion-step-title">好友完成新用户首次体验</h5>
            <p class="promotion-step-desc">链接 72 小时内有效，好友在时效内体验BioIntelOS</p>
          </div>
        </div>

        <div class="promotion-step-item">
          <span class="promotion-step-number gold"><img :src="num3" class="step-num-img" /></span>
          <div class="promotion-step-content">
            <h5 class="promotion-step-title">分享人获得 5000 碱基币奖励</h5>
            <p class="promotion-step-desc">无使用期限，尽享科研加速之旅</p>
          </div>
        </div>
      </div>

      <!-- 底部统计 -->
      <div class="promotion-stats-section">
        <div class="promotion-stat">
          <span class="promotion-stat-label">累计获得碱基币</span>
          <div class="promotion-stat-row">
            <img :src="iconCoinStar" alt="" class="promotion-stat-icon" />
            <span class="promotion-stat-value">{{ formatCredits(promotionStats.total_reward) }}</span>
          </div>
        </div>
        <div class="promotion-stats-divider"></div>
        <div class="promotion-stat">
          <span class="promotion-stat-label">累计邀请好友</span>
          <div class="promotion-stat-row">
            <img :src="iconInvite" alt="" class="promotion-stat-icon" />
            <span class="promotion-stat-value">{{ promotionStats.total_referrals || 0 }}</span>
          </div>
        </div>
      </div>

      <!-- 关闭按钮 -->
      <button class="close-btn" type="button" @click="goBack">
        <svg viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { getMyPromotionStats, getMyPromotionLinks, createPromotionLink } from '@/api/promotion'
import headerBanner from '@/assets/promotion/bg.png'
import iconLink from '@/assets/promotion/icon-link.svg'
import iconCoinStar from '@/assets/promotion/icon-coin-star.svg'
import iconInvite from '@/assets/promotion/icon-invite.svg'
import num1 from '@/assets/promotion/num1.svg'
import num2 from '@/assets/promotion/num2.svg'
import num3 from '@/assets/promotion/num3.svg'

const promotionStats = ref({ total_referrals: 0, total_reward: 0 })
const promotionLink = ref(null)

const loadPromotionData = async () => {
  try {
    const [linksRes, statsRes] = await Promise.all([
      getMyPromotionLinks(),
      getMyPromotionStats()
    ])
    promotionStats.value = statsRes.data.data || { total_referrals: 0, total_reward: 0 }
    const links = linksRes.data.data || []
    if (links.length > 0) {
      promotionLink.value = links[0]
    } else {
      await createPromotionLink({})
      const newLinks = await getMyPromotionLinks()
      const newList = newLinks.data.data || []
      promotionLink.value = newList.length > 0 ? newList[0] : null
    }
  } catch (e) {
    console.error('加载推广信息失败', e)
  }
}

const openRule = () => {
  window.open('https://ncn5iwd5i2fq.feishu.cn/wiki/FmGRw7dA8i2HsQkZWIAcnV4qnje?from=from_copylink', '_blank')
}

const copyPromotionLink = () => {
  if (!promotionLink.value?.refLink) {
    ElMessage.warning('推广链接加载中，请稍后再试')
    return
  }
  const shareText = `科研党速冲！AI生信平台 BioIntelOS，邀请好友领 5000 碱基币，做生信再也不用求人了，链接：${promotionLink.value.refLink}`
  navigator.clipboard.writeText(shareText).then(() => {
    ElMessage.success('已复制到剪贴板')
  }).catch(() => {
    ElMessage.error('复制失败，请手动复制')
  })
}

const formatCredits = (value) => {
  if (!value && value !== 0) return '0'
  return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const emit = defineEmits(['close'])

const goBack = () => {
  emit('close')
}

onMounted(() => {
  loadPromotionData()
})
</script>

<style scoped>
.promotion-modal-page {
  display: contents;
}

.promotion-card {
  position: relative;
  width: 400px;
  background: #F5F5F7;
  border-radius: 20px;
  overflow: hidden;
}

.promotion-header {
  position: relative;
  width: 100%;
  height: 226px;
  overflow: hidden;
}

.promotion-header-bg {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.promotion-header-content {
  position: absolute;
  left: 16px;
  top: 20px;
  z-index: 1;
}

.promotion-title {
  font-family: var(--font-family-sans);
  font-size: 26px;
  font-weight: 400;
  line-height: 34px;
  letter-spacing: -0.3px;
  color: #1A1A2E;
  margin: 0 0 4px;
}

.promotion-subtitle {
  font-family: var(--font-family-sans);
  font-size: 26px;
  font-weight: 400;
  line-height: 34px;
  letter-spacing: -0.3px;
  color: #1A1A2E;
  margin: 0 0 8px;
}

.promotion-subtitle .highlight-text {
  color: #0840e6;
  font-size: 26px;
  font-weight: 400;
}

.promotion-desc {
  font-family: var(--font-family-sans);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #1A1A2E;
  margin: 0;
}

.rule-link {
  display: block;
  font-family: var(--font-family-sans);
  color: #0840e6;
  text-decoration: underline;
  font-size: 12px;
  line-height: 18px;
  margin-top: 4px;
}

.rule-link:hover {
  text-decoration: underline;
}

.promotion-copy-btn {
  position: absolute;
  left: 16px;
  top: 161px;
  width: 368px;
  height: 42px;
  background: #0840E6;
  border-radius: 8px;
  border: none;
  color: #ffffff;
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.promotion-copy-btn:hover {
  background: #0635c0;
}

.link-icon {
  width: 16px;
  height: 16px;
}

.promotion-steps-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px 16px 20px;
  gap: 16px;
  background: #F5F7F8;
}

.promotion-steps-title {
  font-family: var(--font-family-sans);
  font-size: 18px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.1px;
  color: #1A1A2E;
  margin: 0;
  text-align: center;
  align-self: center;
}

.promotion-step-item {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 14px 16px;
  background: #ffffff;
  border-radius: 12px;
  align-self: stretch;
}

.promotion-step-number {
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  font-weight: 700;
  font-style: italic;
  border-radius: 10px;
  background: #f5f7f8;
}

.promotion-step-number.blue {
  color: #0840e6;
}

.promotion-step-number.purple {
  color: #9b41ae;
}

.promotion-step-number.gold {
  color: #cfac74;
}

.step-num-img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.promotion-step-content {
  flex: 1;
}

.promotion-step-title {
  font-family: var(--font-family-sans);
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  color: #1A1A2E;
  margin: 0 0 2px;
}

.promotion-step-desc {
  font-family: var(--font-family-sans);
  font-size: 11.5px;
  font-weight: 400;
  line-height: 18px;
  color: #9CA3AF;
  margin: 0;
}

.promotion-stats-section {
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  padding: 27px 16px 32px 23px;
  height: 112px;
  background: #FFFFFF;
  border-top: 0.8px solid #EFEFEF;
  align-self: stretch;
}

.promotion-stat {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.promotion-stat-label {
  font-size: 12px;
  color: #999999;
}

.promotion-stat-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.promotion-stat-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.promotion-stat-value {
  font-size: 22px;
  font-weight: 400;
  color: #1a1a1a;
}

.promotion-stats-divider {
  width: 1px;
  height: 40px;
  background: #e8e8e8;
  margin: 0 12px 0 17px;
  align-self: center;
}

.close-btn {
  position: absolute;
  right: 12px;
  top: 12px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.2s;
  z-index: 10;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.5);
}

.close-btn svg {
  width: 16px;
  height: 16px;
  color: #666666;
}
</style>
